import Pagination from "./Pagination";
import { useEffect, useRef, useState } from "react";
import { ChevronUpDownIcon, EyeIcon, TrashIcon as TrashIconOutline } from "@heroicons/react/24/outline";
import { Button } from "./Button";
import { Input } from "./Input";
import MasterTitle from "./MasterTitle";
import { Checkbox } from "./Checkbox";
import Records from "./Records";
import { SortData } from "./SortData";
import FloatNotification from "./FloatNotification";
import Select from "./Select";
import { TrashIcon } from "@heroicons/react/20/solid";
import DeletePopup from "./DeletePopup";
import { Api } from "../Api/Api";
import { ErrorToast, SuccessToast } from "./toast";
import NoDataFound from "./NoDataFound";
import CircularProgress from "@mui/material/CircularProgress";
import ActionButton from "./ActionButton";
import ActionPopup from "./ActionPopup";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setPaperData } from "../redux/actions/paperDataAction";

const TableAction = ({
    onPreview,
    onDelete,
    accessDelete,
    accessPreview = true,
}) => {
    return (
        <div className="flex items-center gap-3">
            {accessPreview && (
                <button
                    type="button"
                    onClick={onPreview}
                    className="group flex items-center text-sm text-gray-700 hover:text-blue-500 hover:scale-125 transition-all duration-150"
                >
                    <EyeIcon className="h-5 w-5" aria-hidden="true" />
                </button>
            )}
            {accessDelete && (
                <button
                    type="button"
                    onClick={onDelete}
                    className="group flex items-center text-sm text-gray-700 hover:text-red-500 hover:scale-125 transition-all duration-150"
                >
                    <TrashIconOutline className="h-5 w-5" aria-hidden="true" />
                </button>
            )}
        </div>
    );
};

const SamplePaper = (props) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const access = props?.access?.filter((e) => e?.name === "Master")?.[0];
    const [openModel, setOpenModel] = useState(false);
    const cancelButtonRef = useRef(null);
    const [showFloatNotification, setShowFloatNotification] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(50);
    const [ChapterData, setChapterData] = useState([]);
    const [PaperGenerationData, setPaperGenerationData] = useState([]);
    const [dataCount, setDataCount] = useState(0);
    const lastIndex = (currentPage - 1) * recordsPerPage;
    const firstIndex = lastIndex;
    const npage = Math.ceil(dataCount / recordsPerPage);
    const numbers = [...Array(npage + 1).keys()].slice(1);
    const [chapterInputData, setChapterInputData] = useState({});
    const [subjectData, setSubjectData] = useState([]);
    const [standardData, setStandardData] = useState([]);
    const [semesterData, setSemesterData] = useState([]);
    const [isLoader, setIsLoader] = useState(false);
    const [SelectChapterId, setSelectChapterId] = useState();
    const [isModelLoader, setisModelLoader] = useState(false);
    const [search, setSearch] = useState("");
    const [mediumData, setMediumData] = useState([]);
    const [boardData, setBoardData] = useState([]);

    const [checkedItems, setCheckedItems] = useState([]);
    const [deleteType, setDeleteType] = useState("single");
    const [isResetFilter, setIsResetFilter] = useState(false);
    const [papergenfilter, setpapergenfilter] = useState({
        board: "",
        medium: "",
        standard: "",
        semester: "",
        subject: "",
    });

    const [titleData, setTitleData] = useState([
        {
            title: "PAPER ID",
            sort: 1,
            fieldName: "id",
        },
        {
            title: "PAPER TYPE",
            sort: 1,
            fieldName: "paper_type",
        },
        // {
        //     title: "USER NAME",
        //     sort: 1,
        //     fieldName: "user_name",
        // },
        {
            title: "CHAPTER NAME",
            sort: 1,
            fieldName: "chapter_name"
        },
        {
            title: "MARK",
            sort: 1,
            fieldName: "exam_marks",
        },
        {
            title: "MOBILE",
            sort: 1,
            fieldName: "mobile",
        },
        {
            title: "SCHOOL NAME",
            sort: 1,
            fieldName: "school_name",
        },
        {
            title: "STANDARD NAME",
            sort: 1,
            fieldName: "standard_name",
        },
        {
            title: "SUBJECT NAME",
            sort: 1,
            fieldName: "subject_name",
        },
        {
            title: "ACTION",
            sort: 1,
            fieldName: "action",
        }
    ]);





    useEffect(() => {
        if (isResetFilter) {
            setIsResetFilter(false);
        }
    }, [isResetFilter]);


    const handleFilter = (name, value) => {
        setpapergenfilter({
            ...papergenfilter,
            [name]: value,
        });
        if (name === "board") {
            setpapergenfilter((oldValue) => ({
                ...oldValue,
                medium: "",
                standard: "",
                semester: "",
                subject: "",
                [name]: value,
            }));
            setMediumData([]);
            setStandardData([]);
            setSemesterData([]);
            setSubjectData([]);
        }
        if (name === "medium") {
            setpapergenfilter((oldValue) => ({
                ...oldValue,
                standard: "",
                semester: "",
                subject: "",
                [name]: value,
            }));
            setStandardData([]);
            setSemesterData([]);
            setSubjectData([]);
        }
        if (name === "standard") {
            setpapergenfilter((oldValue) => ({
                ...oldValue,
                semester: "",
                subject: "",
                [name]: value,
            }));
            setSemesterData([]);
            setSubjectData([]);
        }
        if (name === "semester") {
            setpapergenfilter((oldValue) => ({
                ...oldValue,
                subject: "",
                [name]: value,
            }));
            setSubjectData([]);
        }
    };

    const resetFilter = () => {
        setIsResetFilter(true);
        setpapergenfilter({
            board: "",
            medium: "",
            standard: "",
            semester: "",
            subject: "",
        });
        setMediumData([]);
        setStandardData([]);
        setSemesterData([]);
        setSubjectData([]);
    };

    const getChapterData = async (search, limit, offset) => {
        try {
            setIsLoader(true);
            const { data } = await Api.getRequest(
                `api/sample-paper?offset=${offset}&limit=${limit}&search=${search || ""}&board=${papergenfilter?.board?.id || ""
                }&medium=${papergenfilter?.medium?.id || ""}&standard=${papergenfilter?.standard?.id || ""
                }&semester=${papergenfilter?.semester?.id || ""}&subject=${papergenfilter?.subject?.id || ""
                }`
            );
            const req = JSON.parse(data);
            if (req?.status === 200) {
                setChapterData(req?.data);
                setDataCount(req?.totalCount);
                setIsLoader(false);
            } else {
                setIsLoader(false);
            }
        } catch (error) {
            ErrorToast(error?.message);
            setIsLoader(false);
        }
    };


    const getBoardData = async () => {
        try {
            const { data } = await Api.getRequest(`api/board`);
            const req = JSON.parse(data);
            setBoardData(req?.data);
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    const getMediumData = async () => {
        try {
            let body = `?board=${papergenfilter?.board?.id}`;
            const { data } = await Api.getRequest(`api/medium${body}`);
            const req = JSON.parse(data);
            setMediumData(req?.data);
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    const getStandardData = async () => {
        try {
            let body = `?medium=${papergenfilter?.medium?.id}`;
            const { data } = await Api.getRequest(`api/standard${body}`);
            const req = JSON.parse(data);
            setStandardData(req?.data);
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    const getSemesterData = async () => {
        try {
            let body = `?standard=${papergenfilter?.standard?.id}`;
            const { data } = await Api.getRequest(`api/v2/semester${body}`);
            const req = JSON.parse(data);
            setSemesterData(req?.data?.rows);
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    const getSubjectData = async () => {
        try {
            let body = `?semester=${papergenfilter?.semester?.id}`;
            const { data } = await Api.getRequest(`api/v2/subject${body}`);
            const req = JSON.parse(data);
            setSubjectData(req?.data);
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    useEffect(() => {
        getBoardData();
    }, []);

    useEffect(() => {
        if (chapterInputData?.board) {
            getMediumData();
        }
    }, [chapterInputData?.board]);

    useEffect(() => {
        if (chapterInputData?.medium) {
            getStandardData();
        }
    }, [chapterInputData?.medium]);

    useEffect(() => {
        if (chapterInputData?.standard) {
            getSemesterData();
        }
    }, [chapterInputData?.standard]);

    useEffect(() => {
        if (chapterInputData?.semester) {
            getSubjectData();
        }
    }, [chapterInputData?.semester]);


    const _deleteChapter = async (id) => {
        try {
            let data;
            if (deleteType === "multi") {
                const body = {
                    ids: checkedItems,
                };
                const response = await Api.deleteRequest(`api/sample-paper/delete`, body);
                data = response.data;
            } else {
                const body = {
                    ids: [SelectChapterId],
                };
                const response = await Api.deleteRequest(`api/sample-paper/delete`, body);
                data = response.data;
            }
            // const { data } = await Api.postRequest(
            //   `api/v2/chapter/delete/${SelectChapterId}`
            // );
            const req = JSON.parse(data);
            if (req?.status === 200) {
                SuccessToast(req?.message);
                getChapterData(search, recordsPerPage, currentPage);
                setOpenModel(false);
                setSelectChapterId("");
            } else {
                ErrorToast(req?.message);
            }
        } catch (error) {
            ErrorToast(error?.message);
        }
    };

    const handlePreview = async (dataRow) => {
        try {
            const url = dataRow?.paperInfo?.pdf_url
            return window.open(url, "_blank");
        } catch (error) {
            ErrorToast(error?.message);
        }
    };




    useEffect(() => {
        if (papergenfilter["board"] !== "") {
            getMediumData();
        }
    }, [papergenfilter["board"]]);

    useEffect(() => {
        if (papergenfilter["medium"] !== "") {
            getStandardData();
        }
    }, [papergenfilter["medium"]]);

    useEffect(() => {
        if (papergenfilter["standard"] !== "") {
            getSemesterData();
        }
    }, [papergenfilter["standard"]]);

    useEffect(() => {
        if (papergenfilter["semester"] !== "") {
            getSubjectData();
        }
    }, [papergenfilter["semester"]]);

    useEffect(() => {
        getChapterData(search, recordsPerPage, currentPage);
    }, [recordsPerPage, currentPage]);

    const applyFilter = () => {
        getChapterData(search, recordsPerPage, currentPage);
    };

    const handleCheckboxChange = (id) => {
        setCheckedItems((prevState) => {
            const isChecked = prevState.includes(id);

            const updatedItems = isChecked
                ? prevState.filter((itemId) => itemId !== id)
                : [...prevState, id];

            return updatedItems;
        });
    };

    return (
        <div>
            <div className="w-full sm:px-0 flex items-start gap-x-4 mr-4">
                <div className="w-full">
                    <Select
                        data={boardData || []}
                        value={papergenfilter?.board}
                        onChange={(e) => handleFilter("board", e)}
                        className="font-regular hover:outline-none hover:border-[#138CE3] hover:ring-[#138CE3]"
                        placeholder="All Board"
                        type="board"
                        getBoard={getBoardData}
                    />
                </div>

                {console.log(papergenfilter?.board, "boardData")}
                {console.log(chapterInputData, "chapterInputData")}

                <div className="w-full">
                    <Select
                        data={mediumData || []}
                        value={papergenfilter?.medium}
                        onChange={(e) => handleFilter("medium", e)}
                        className="font-regular hover:outline-none hover:border-[#138CE3] hover:ring-[#138CE3]"
                        placeholder="All Medium"
                        type="medium"
                        getMedium={getMediumData}
                    />
                </div>
                <div className="w-full">
                    <Select
                        data={standardData || []}
                        value={papergenfilter?.standard}
                        onChange={(e) => handleFilter("standard", e)}
                        className="font-regular hover:outline-none hover:border-[#138CE3] hover:ring-[#138CE3]"
                        placeholder="All Standard"
                        type={"standard"}
                        getStandard={getStandardData}
                    />
                </div>
                <div className="w-full">
                    <Select
                        data={semesterData || []}
                        value={papergenfilter?.semester}
                        onChange={(e) => handleFilter("semester", e)}
                        className="font-regular hover:outline-none hover:border-[#138CE3] hover:ring-[#138CE3]"
                        placeholder="All Semester"
                        type={"semester"}
                        getSemester={getSemesterData}
                    />
                </div>
                <div className="w-full">
                    <Select
                        data={subjectData || []}
                        value={papergenfilter?.subject}
                        onChange={(e) => handleFilter("subject", e)}
                        className="font-regular hover:outline-none hover:border-[#138CE3] hover:ring-[#138CE3]"
                        placeholder="All Subject"
                        type={"subject"}
                        getSubject={getSubjectData}
                    />
                </div>
                <div className="mt-3">
                    <Button
                        onClick={() => applyFilter()}
                        id="filterbtn"
                        type="button"
                        label={"SEARCH"}
                    />
                </div>
                <div className="mt-3">
                    <Button
                        onClick={() => resetFilter()}
                        id=""
                        type="button"
                        label={"RESET"}
                    />
                </div>
            </div>


            <div className="flex justify-between items-center mt-4">
                <div>
                    <MasterTitle
                        title="Sample Paper"
                        description="Below are all the list of sample paper's."
                    />
                </div>

                <div>
                    {" "}
                    <div style={{ display: "flex", gap: "5px" }}>
                        {access?.delete && (
                            <Button
                                id=""
                                type="submit"
                                icon={TrashIcon}
                                label={"DELETE PAPER"}
                                onClick={() => {
                                    setDeleteType("multi");
                                    if (checkedItems.length > 0) {
                                        setOpenModel(true);
                                    }
                                }}
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="sm:mb-0 overflow-hidden ">
                <div className="flex flex-col mt-4">
                    <section className="bg-white rounded-2xl flex flex-col shadow-sm h-full " style={{
                        width: "100%",
                        height: "75vh",
                        margin: "0 auto",
                        padding: "10px",
                    }}>
                        <div className="flex justify-between items-center mt-6 px-8 mb-3">
                            <div style={{ display: "flex", gap: '5px' }}>
                                <Input
                                    id=""
                                    name="Search"
                                    type="text"
                                    placeholder="Search here..."
                                    autoComplete="given-name"
                                    required
                                    className="w-72"
                                    onChange={(e) => {
                                        setSearch(e?.target?.value);
                                        setCurrentPage(1);
                                    }}
                                    value={search}
                                />
                                <Button
                                    onClick={() => applyFilter()}
                                    id=""
                                    type="button"
                                    // label={"SEARCH"}
                                    searchicon={true}
                                />
                            </div>
                            <div>
                                <Records
                                    recordsPerPage={recordsPerPage}
                                    setRecordsPerPage={setRecordsPerPage}
                                    setCurrentPage={setCurrentPage}
                                    dataCount={dataCount}
                                />
                            </div>
                        </div>
                        <div className="h-[calc(100vh-40px-16px-24px-38px-50px-40px-52px-16px-42px-24px-62px-32px)] overflow-y-auto" style={{
                            overflowY: "auto",
                            maxHeight: "58vh",
                            height: "60vh",
                            width: "100%",
                        }}>
                            {!isLoader && ChapterData?.length <= 0 ? (
                                <NoDataFound />
                            ) : (
                                <table className="w-full">
                                    <thead
                                        className="sticky top-0 bg-white"
                                        style={{ zIndex: 1 }}
                                    >
                                        <tr className="border-b border-gray-200 text-left text-xs leading-4 font-bold text-[#7B809A] tracking-wider">
                                            <th
                                                scope="col"
                                                className="relative w-12 px-6 sm:w-16 sm:px-8"
                                            ></th>
                                            {titleData.map(
                                                (v, ind) =>
                                                    v.title && (
                                                        <th
                                                            key={ind}
                                                            className="py-4 px-8 "
                                                            style={{
                                                                backgroundColor: "white",
                                                                position:
                                                                    v.title === "ACTION"
                                                                        ? "sticky"
                                                                        : "",
                                                                right:
                                                                    v.title === "ACTION"
                                                                        ? "0"
                                                                        : "",
                                                            }}
                                                        >
                                                            <div className="flex justify-between">
                                                                <span>{v.title}</span>
                                                                {v.title !== "ACTION" && (
                                                                    <span>
                                                                        <ChevronUpDownIcon
                                                                            onClick={() => {
                                                                                let res = SortData(
                                                                                    ChapterData,
                                                                                    v.fieldName,
                                                                                    v.sort
                                                                                );

                                                                                let copyData = [...titleData];
                                                                                copyData[ind].sort =
                                                                                    v.sort > 0 ? -1 : 1;
                                                                                setTitleData(copyData);
                                                                                setChapterData(res);
                                                                            }}
                                                                            className="w-5 h-5"
                                                                        />
                                                                    </span>
                                                                )}
                                                            </div>
                                                        </th>
                                                    )
                                            )}
                                        </tr>
                                    </thead>
                                    <tbody className="divide-y divide-gray-200">
                                        {isLoader ? (
                                            <tr style={{ height: "25rem" }}>
                                                <td colSpan={7} style={{ textAlign: "center" }}>
                                                    <CircularProgress />
                                                </td>
                                            </tr>
                                        ) : (
                                            ChapterData.map((data) => (
                                                <tr
                                                    key={data.key}
                                                    className="my-4 p-8 text-[#000] font-reguler text-sm font-medium"
                                                >
                                                    <td className="px-6 py-3 whitespace-no-wrap">
                                                        {/* <Checkbox type="checkbox" />   */}
                                                        <Checkbox
                                                            checked={checkedItems.includes(data.id)}
                                                            onChange={() => handleCheckboxChange(data.id)}
                                                        />
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data.id || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data.paperInfo?.paper_type || "-"}
                                                    </td>
                                                    {/* <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data?.paperInfo?.user?.username || "-"}
                                                    </td> */}
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data?.paperInfo?.chapter_name || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data?.paperInfo?.exam_marks || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data?.paperInfo?.user?.mobile || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data.paperInfo?.school_name || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data.paperInfo?.standard_name || "-"}
                                                    </td>
                                                    <td className="lg:table-cell whitespace-nowrap py-2.5 px-8">
                                                        {data.paperInfo?.subject_name || "-"}
                                                    </td>
                                                    <td
                                                        className="relative whitespace-nowrap  px-6 py-2.5  text-left"
                                                        style={{
                                                            position: "sticky",
                                                            right: "0",
                                                            backgroundColor: "white",
                                                        }}
                                                    >
                                                        <TableAction
                                                            accessDelete={access?.delete}
                                                            accessPreview={true}
                                                            onDelete={() => {
                                                                setDeleteType("single");
                                                                setOpenModel(true);
                                                                setSelectChapterId(data?.id);
                                                            }}
                                                            onPreview={() => handlePreview(data)}
                                                        />
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            )}
                        </div>
                        <Pagination
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                            recordsPerPage={recordsPerPage}
                            data={ChapterData}
                            numbers={numbers}
                            npage={npage}
                            lastIndex={lastIndex}
                            firstIndex={firstIndex}
                            dataCount={dataCount}
                        />
                    </section>
                </div>
                {/* Delete */}
                <DeletePopup
                    title={"Delete"}
                    show={openModel}
                    description="Are you sure you want to delete this Data ? All data
            of this Data will be permanently removed from our
            servers forever. This action cannot be undone."
                    onCancel={() => {
                        setOpenModel(false);
                        setSelectChapterId("");
                    }}
                    onClose={() => {
                        setOpenModel(false);
                        setSelectChapterId("");
                    }}
                    onDelete={() => {
                        _deleteChapter();
                    }}
                    cancelButtonRef={cancelButtonRef}
                    okText="Delete"
                    cancelText="Cancel"
                />

                {/* Delete */}
                <FloatNotification
                    show={showFloatNotification}
                    title={"Successfully deleted!"}
                    type="success"
                    description={"Data Deleted."}
                    onClick={() => {
                        setShowFloatNotification(false);
                    }}
                />
            </div>
        </div>
    );
};

export default SamplePaper;
